/* global femcare, axios */

femcare.quiz.standard = {
    init: async function () {
        var $quiz = $('.quiz.quiz--standard');

        if (!$quiz.length) {
            return;
        }

        const antiforgeryToken = await femcare.form.protection.provideCSRFToken();

        function StandardQuiz() {
            femcare.quiz.BaseQuiz.call(this, $quiz);

            this.$progressBar = this.$questionnaire.find('.questionnaire__progress-bar');
            this.$userDataFieldset = this.$questionnaire.find(
                '.questionnaire__step--user-data'
            );
            this.$recaptcha = this.$quiz.find('.g-recaptcha');

            this.results = window.quiz.results;
            this.defaultResult = window.quiz.defaultResult;
            this.requestUserData = window.quiz.requestUserData;
            this.userDataSkipped = false;
        }

        StandardQuiz.prototype = Object.create(femcare.quiz.BaseQuiz.prototype);
        StandardQuiz.prototype.constructor = StandardQuiz;

        StandardQuiz.prototype.initDerivedEventHandlers = function () {
            var $skip = this.$questionnaire.find('.questionnaire__skip');
            $skip.click(this.skip.bind(this));

            this.$questionnaire.find('form').submit(function (e) {
                e.preventDefault();
            });

            femcare.shared.inputs.initSubmitConsent(this.$userDataFieldset);
        };

        StandardQuiz.prototype.prepareQuestionnaire = function () {
            this.userDataSkipped = false;

            this.$questionnaire.find('.form-group.has-error').removeClass('has-error');
            this.$questionnaire.find('.form-group.success').removeClass('success');
            this.$questionnaire.find('form').trigger('reset');

            this.$result.find('.quiz-result__body').empty();

            if (this.$recaptcha.length) {
                window.grecaptcha.reset();
            }

            this.setProgessBar(0);
            this.$steps
                .hide()
                .first()
                .show();
        };

        StandardQuiz.prototype.setProgessBar = function (stepIndex) {
            var stepCount = this.$steps.length - 1;
            var fillPercent = (100 / stepCount) * stepIndex;
            this.$progressBar.css('width', Math.ceil(fillPercent) + '%');
        };

        StandardQuiz.prototype.skip = function(e) {
        this.userDataSkipped = true;

        const $currentStep = $(e.currentTarget).closest('.questionnaire__step');
        const currentStepIndex = $currentStep.index('.questionnaire__step');
        const nextStepIndex = currentStepIndex + 1;

        if (nextStepIndex < this.$steps.length) {
            const $nextStep = $(this.$steps[nextStepIndex]);
            this.switchToStep($nextStep);
        } else {
            this.finish();
        }

        this.scrollTop();
        };

        StandardQuiz.prototype.prepareStep = function ($step) {
            this.setProgessBar($step.index() - 1);
            $step.find('.form-group.has-error').removeClass('has-error');
        };

        StandardQuiz.prototype.prepareResult = function () {
            var answers = this.getAnswers();
            var result = null;

            var matchResultByTag = this.results.length && this.results[0].tag;
            var matchResultByIdSet =
                this.results.length && this.results[0].answerGroups.length;

            if (matchResultByTag) {
                result = this.getResultByTagPrevalence(answers.tags);
            } else if (matchResultByIdSet) {
                result = this.getResultByIdSet(answers.ids);
            }

            this.renderResult(result);
        };

        StandardQuiz.prototype.getAnswers = function () {
            var answers = { ids: [], tags: [] };

            var $answers = this.$steps
                .filter('.questionnaire__step--question')
                .find('input:checked, option:selected');

            $answers.each(function (index, element) {
                var $answer = $(element);
                answers.ids.push($answer.val());
                answers.tags.push($answer.data('tag'));
            });

            return answers;
        };

        StandardQuiz.prototype.getResultByTagPrevalence = function (answerTags) {
            var tagsCount = {};

            for (var tagIndex = 0; tagIndex < answerTags.length; tagIndex++) {
                var tagCount = tagsCount[answerTags[tagIndex]];
                tagsCount[answerTags[tagIndex]] = tagCount ? tagCount + 1 : 1;
            }

            var prevalentTag = null;
            var prevalentTagCount = 0;

            Object.keys(tagsCount).forEach(function (tag) {
                var count = tagsCount[tag];
                if (count > prevalentTagCount) {
                    prevalentTag = tag;
                    prevalentTagCount = count;
                }
            });

            var matchingResults = this.results.filter(function (result) {
                return result.tag === prevalentTag;
            });
            var matchingResult = matchingResults.length === 1 ? matchingResults[0] : null;

            return matchingResult;
        };

        StandardQuiz.prototype.getResultByIdSet = function (answerIds) {
            var result = null;

            for (
                var resultIndex = 0;
                !result && resultIndex < this.results.length;
                resultIndex++
            ) {
                var resultIdSets = this.results[resultIndex].answerGroups;

                for (var idSetIndex = 0; idSetIndex < resultIdSets.length; idSetIndex++) {
                    var idSet = resultIdSets[idSetIndex];

                    var setMatched = idSet.every(function (answerId) {
                        return answerIds.indexOf(String(answerId)) >= 0;
                    });

                    if (setMatched) {
                        result = this.results[resultIndex];
                        break;
                    }
                }
            }

            return result;
        };

        StandardQuiz.prototype.renderResult = function (result) {
            var $resultHeading = this.$result.find('.quiz-result__heading');
            var $resultBody = this.$result.find('.quiz-result__body');
            var $resultImage = this.$result.find('.quiz-result__image');
            var $resultLink = this.$result.find('.quiz-result__link');

            if (result) {
                $resultHeading.text(result.title);
                $resultBody.append(result.description);

                var image = result.images && result.images[0];

                if (image) {
                    $resultImage
                        .find('img')
                        .attr('src', image.src)
                        .attr('alt', image.altText);

                    $resultImage.show();
                }

                if (result.link) {
                    $resultLink
                        .text(result.link.text)
                        .attr('title', result.link.title)
                        .attr('target', result.link.target)
                        .attr('href', result.link.href);

                    $resultLink.show();
                }
            } else {
                $resultHeading.text(this.defaultResult.title);
                $resultBody.text(this.defaultResult.description);
                $resultImage.hide();
                $resultLink.hide();
            }
        };

        StandardQuiz.prototype.getUserData = function () {
            var data = {};

            this.$steps
                .filter('.questionnaire__step--user-data')
                .find('input, select')
                .each(function (index, field) {
                    var $field = $(field);

                    // Skip unchecked checkboxes
                    if ($field.is(':checkbox') && !$field.prop('checked')) {
                        return;
                    }

                    data[$field.attr('name')] = $field.val();
                });

            return data;
        };

        StandardQuiz.prototype.post = function () {
            const data = {
                id: this.id,
                answers: this.getAnswers().ids,
                userData: this.requestUserData && !this.userDataSkipped ? this.getUserData() : null,
                userDataSkipped: this.userDataSkipped,
                recaptcha: this.$recaptcha.length ? window.grecaptcha.getResponse() : null
            };

            axios({
                method: 'POST',
                url: this.postUrl,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Request-Verification-Token': antiforgeryToken,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: JSON.stringify(data)
            }).catch(error => {
                console.error('Error posting quiz results:', error);
            });
        };

        new StandardQuiz();
    }
};

